import type { Config } from 'dompurify';

export const config: Config = {
    ALLOWED_TAGS: [
        // Заголовки
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        // Форматирование
        'p',
        'br',
        'strong',
        'b',
        'em',
        'i',
        'u',
        's',
        'del',
        'mark',
        'code',
        'pre',
        'blockquote',
        // Списки
        'ul',
        'ol',
        'li',
        // Разделители
        'hr',
        // Таблицы
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
        // Контейнеры
        'div',
        'span',
        // KaTeX математические формулы
        'math',
        'semantics',
        'mrow',
        'mi',
        'mn',
        'mo',
        'mfrac',
        'msup',
        'msub',
        'msubsup',
        'msqrt',
        'mroot',
        'mtext',
        'mspace',
        'menclose',
        'mpadded',
        'mphantom',
        'mfenced',
        'mtable',
        'mtr',
        'mtd',
        'mlabeledtr',
        'maligngroup',
        'malignmark',
        'mstyle',
        'merror',
        'munder',
        'mover',
        'munderover',
        'mmultiscripts',
        'mprescripts',
        'none',
        'annotation',
        // markdown-it-texmath элементы
        'section',
        'eqn',
        'eq',
    ],
    ALLOWED_ATTR: [
        'title',
        'class',
        'style',
        'href',
        'target',
        'rel',
        // KaTeX атрибуты
        'xmlns',
        'display',
        'mathvariant',
        'fence',
        'separator',
        'stretchy',
        'symmetric',
        'largeop',
        'movablelimits',
        'accent',
        'lspace',
        'rspace',
        'linethickness',
        'width',
        'height',
        'depth',
        'notation',
        'voffset',
        'open',
        'close',
        'separators',
        'align',
        'rowalign',
        'columnalign',
        'groupalign',
        'alignmentscope',
        'columnwidth',
        'rowspacing',
        'columnspacing',
        'rowlines',
        'columnlines',
        'frame',
        'framespacing',
        'equalrows',
        'equalcolumns',
        'displaystyle',
        'side',
        'minlabelspacing',
        'rowspan',
        'columnspan',
        'edge',
        'scriptlevel',
        'scriptsizemultiplier',
        'scriptminsize',
        'infixlinebreakstyle',
        'decimalpoint',
        'mathsize',
        'valign',
        'form',
        'maxsize',
        'minsize',
        'linebreak',
        'lineleading',
        'linebreakstyle',
        'linebreakmultchar',
        'indentalign',
        'indentshift',
        'indenttarget',
        'indentalignfirst',
        'indentshiftfirst',
        'indentalignlast',
        'indentshiftlast',
        'accentunder',
        'subscriptshift',
        'superscriptshift',
        'encoding',
    ],
    FORCE_BODY: true, // Безопасно возвращает body.innerHTML
};
